// extracted by mini-css-extract-plugin
module.exports =  {"signUpContainer":"SignUpComponent_signUpContainer__oLhG3","signInLinkContainer":"SignUpComponent_signInLinkContainer__QbVbB"};